var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkJawwalPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 24,
    viewBox: "0 0 56 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.098 18.35c.023-.072.038-.124.056-.175a9762.83 9762.83 0 0 1 3.41-9.656c.069-.17.153-.333.25-.488a.6.6 0 0 1 .505-.315c.315-.015.632-.01.947.008.183.01.349.11.442.268.102.146.188.303.256.469 1.012 2.837 2.02 5.677 3.024 8.519.146.409.285.82.427 1.23.014.042.023.085.035.13-.534 0-1.068.028-1.59-.009-.344-.024-.531-.303-.647-.608a93.263 93.263 0 0 1-.614-1.68.18.18 0 0 0-.2-.143c-1.09.004-2.181.004-3.272 0-.127 0-.17.048-.207.157-.185.549-.377 1.095-.567 1.643-.166.48-.4.652-.903.655-.445-.002-.889-.005-1.352-.005zm4.718-7.59h-.074l-1.135 3.384h2.337l-1.128-3.384zM32.892 14.32v3.068c.001.095-.003.19-.014.284-.04.352-.237.596-.588.625-.418.034-.84.008-1.281.008V8.653c-.002-.079 0-.157.007-.235.05-.402.267-.63.668-.7.098-.017.198-.025.298-.025h3.37c.575 0 1.131.097 1.648.357.922.469 1.42 1.236 1.585 2.24a4.464 4.464 0 0 1-.148 2.084c-.325 1.022-1.042 1.625-2.076 1.84-.35.065-.704.099-1.06.1-.734.015-1.468.005-2.203.005h-.206zm.008-1.849a.323.323 0 0 0 .067.014c.868 0 1.736 0 2.604-.004.224 0 .442-.072.623-.205.37-.268.5-.655.55-1.083.099-.864-.305-1.713-1.44-1.675-.738.027-1.478.006-2.217.006-.059 0-.117.006-.182.009l-.005 2.938zM49.8 18.345v-.215c0-1.273 0-2.546-.009-3.818a.609.609 0 0 0-.081-.3c-.858-1.447-1.718-2.893-2.582-4.338-.385-.647-.768-1.294-1.15-1.943-.025-.037-.046-.083-.08-.15h.734c.284 0 .569.01.852 0 .379-.015.633.168.815.48l2.316 3.971c.029.051.066.099.113.172.049-.073.084-.12.113-.171a4502.9 4502.9 0 0 0 2.312-3.993c.164-.281.406-.456.746-.456h1.502a.99.99 0 0 1 .1.013c-.044.075-.078.138-.113.2a9306.857 9306.857 0 0 1-3.596 6.186.82.82 0 0 0-.117.441c.005 1.005.003 2.01 0 3.015 0 .603-.267.885-.868.905-.322.01-.65.001-1.007.001z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.358 15.588-2.86 6.7-.647 1.512h.003a9.2 9.2 0 0 0 3.566.004 8.434 8.434 0 0 0 2.55-1.097c.096-.064.19-.128.283-.194l-2.895-6.925z",
    fill: "#7BB958"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.622 18.53z",
    fill: "#7CBC56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.179 7.594.016 6.073v.001l2.998.935 3.165.985-6.179-7.994z",
    fill: "#226188"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.195 13.668 2.998.935-2.998-.935zM13.177 7.593z",
    fill: "#7CBC56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7.11a7.808 7.808 0 0 0-4.93 2.991l-.04.056c-.024.031-.046.064-.07.096l6.519 4.34-1.48-7.482z",
    fill: "#29A5BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.542 17.194 6.408-1.605-5.43-3.032C.51 14.399.421 16.07.542 17.194z",
    fill: "#7BB958"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.72 10.392z",
    fill: "#7CBC56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.544 17.23.008.063.013.078c.409 2.41 1.686 3.883 2.566 4.641l3.819-6.424-6.408 1.605.002.037z",
    fill: "#68A855"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.397 22.23a.545.545 0 0 1 .044.035l.037.027c1.29.963 2.531 1.583 4.718 1.698a7.809 7.809 0 0 0 1.049-.019c-.585-2.154-2.2-8.077-2.295-8.38v-.003l-3.82 6.424c.095.08.183.153.267.218z",
    fill: "#5B9E54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.245 23.97.002.002.093-.008.06-.006.08-.009c1.355-.158 2.458-.631 3.192-.947.176-.075.33-.142.46-.191-1.49-.906-2.683-2.03-3.605-3.117a17.208 17.208 0 0 1-1.393-1.89 17.62 17.62 0 0 1-.488-.81 8.938 8.938 0 0 1-.354-.664c-.342-.739-.339-.73-.342-.742",
    fill: "#5A9252"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.555 1.467A7.774 7.774 0 0 0 15.198.313a5.729 5.729 0 0 0-1.912-.307l-.038-.001a7.711 7.711 0 0 0-1.475.092c-.023.004-.047.01-.073.013l1.477 7.483 4.482-6.048c-.034-.026-.067-.053-.104-.078z",
    fill: "#1E98B0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.556 5.8a7.843 7.843 0 0 0-2.898-4.254l-4.481 6.047h.002l7.385-1.765-.008-.029z",
    fill: "#218DA5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.861 8.671-.002.1.002-.1zM13.195 13.667a1.035 1.035 0 0 0-.03.01l.03-.009z",
    fill: "#7CBC56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.195 13.668a.322.322 0 0 0-.03.01c-.004 0-.006.001 0 0-.315.093-.384.115-6.215 1.91h12.408l-3.165-.985-2.998-.935z",
    fill: "#95C65B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.165 13.677.03-.009-.03.01z",
    fill: "#7CBC56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.202 9.06-.018.008c-1.549.788-2.8 1.938-3.527 3.249l-.01.018a9.992 9.992 0 0 0-.127.223l5.43 3.031-1.748-6.53z",
    fill: "#83BD5C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.179 7.592-6.518-4.34A7.83 7.83 0 0 0 5.18 7.524c0 .008-.04.59.02 1.524 0 .004 0 .006.002.009.16-.08.32-.157.479-.225V8.83v.004a14.978 14.978 0 0 1 3.642-1.05c.44-.068.883-.118 1.324-.154.865-.069 1.744-.053 2.532-.036z",
    fill: "#25B3C4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.195 13.666-.016-6.072-6.23 7.994c5.832-1.795 5.901-1.82 6.216-1.911-.018.005.026-.01.03-.01z",
    fill: "#9EC95B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.195 13.666-.016-6.073.016 6.073z",
    fill: "#7CBC56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.95 15.587 6.227-7.994c-.786-.018-1.665-.034-2.53.035a18.526 18.526 0 0 0-1.7.217 14.99 14.99 0 0 0-3.266.987v-.004.004a8.843 8.843 0 0 0-.48.225H5.2h.002l1.748 6.53z",
    fill: "#91C45A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.133 17.806zM7.646 16.992zM7.824 17.303zM7.292 16.33zM7.292 16.33c-.227-.45-.337-.727-.342-.738.005.01.115.288.342.739z",
    fill: "#7CBC56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.358 15.588c-.76.305-1.526.618-2.289.932-1.149.473-2.3.954-3.447 1.437a717.563 717.563 0 0 0-3.408 1.446l-.006.002-.681.29c.923 1.087 2.114 2.21 3.604 3.117.606.355 1.394.648 2.536.947l.071.019h.006l.107.022c.016.003-.016-.003 0 0l.647-1.511 2.86-6.7z",
    fill: "#83BD5C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.622 17.956z",
    fill: "#7CBC56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95 15.589v.003c.006.012.115.288.342.739.095.191.214.416.354.663a18.963 18.963 0 0 0 .721 1.166 17.247 17.247 0 0 0 1.16 1.534l.68-.29h.007l1.128-.48 2.28-.967a443.72 443.72 0 0 1 3.447-1.437c.763-.314 1.53-.627 2.29-.932H6.948z",
    fill: "#91C45A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8 7.175a7.933 7.933 0 0 0-.22-1.285l-.016-.062-7.385 1.766 7.54 2.798.001.002c.017-.156.032-.3.05-.446.04-.317.076-.818.089-1.178l.002-.099c.012-.52-.01-1.022-.061-1.496z",
    fill: "#20839F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.465 15.7a8.67 8.67 0 0 0-.43-2.128l-5.677 2.017 5.874 2.509c.147-.6.307-1.45.233-2.398z",
    fill: "#5B9E54"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.232 18.097-5.874-2.509 2.893 6.924c2.058-1.471 2.71-3.454 2.717-3.476.08-.259.143-.48.199-.69h.001l.02-.081.014-.049.002-.01.028-.109z",
    fill: "#68A855"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.179 7.594 6.18 7.994c.007-.017.755-1.33 1.36-5.195l-7.54-2.799z",
    fill: "#267491"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.995 13.454a8.267 8.267 0 0 0-3.021-3.889 7.357 7.357 0 0 0-1.12-.637l.005-.158c-.013.36-.05.86-.089 1.178-.018.146-.035.288-.05.445-.605 3.866-1.354 5.18-1.362 5.195l5.676-2.017-.04-.117z",
    fill: "#5A9252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkJawwalPay);
export default __webpack_public_path__ + "static/media/darkJawwalPay.a1d7d3cd6bae2a888b255c7820692839.svg";
export { ForwardRef as ReactComponent };